export class CompanyProfileResponseModel {
    public country = '';
    public symbol = '';
    public website = '';
    public summaryCDATA = '';
    public summary = '';
}